<div>
  <mat-icon>warning</mat-icon>
  {{ "PAGE_NOT_FOUND" | translate }}
</div>
